<input
        [disableClick]="true"
        [format]="24"
        [ngxTimepicker]="picker"
        class="c-btn galec-hour mt-2"
        [formControl]="control"
        [id]="id"
        type="time"
        (input)="onTimeSet($event.target.value)"
/>

<ngx-material-timepicker-toggle [for]="picker"></ngx-material-timepicker-toggle>

<ngx-material-timepicker
    #picker
    [cancelBtnTmpl]="cancelTpl"
    [confirmBtnTmpl]="confirmTpl"
    (timeSet)="onTimeSet($event)"
></ngx-material-timepicker>

<ng-template #cancelTpl>
    <button class="timepicker-button cancel-btn" timepickerCancelBtn>
        {{ 'UTILS.QUITTER' | translate }}
    </button>
</ng-template>

<ng-template #confirmTpl>
    <button class="timepicker-button confirm-btn" timepickerConfirmBtn>
        {{ 'UTILS.CONFIRMER' | translate }}
    </button>
</ng-template>
